import { Component, OnInit, OnDestroy, ViewChild, ElementRef, ViewEncapsulation, Inject, Injector } from '@angular/core';
import { Widget, DataProvider, LogService, WidegtHelperService, BarChartResponseObject } from 'core-dashboard';
import { TranslateService } from "@ngx-translate/core";
import * as d3 from 'd3';
@Component({
  selector: 'horizontal-bar-chart',
  template: `<div class='d3-chart' #chart></div>`,
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./horizontal.bar.chart.css']
})

export class HorizontalBarChart extends Widget implements OnInit, OnDestroy {

  name: string;
  private widgetStyle: any;
  private dataProvider: any;
  private width: number;
  private height: number;
  private lastHeight: number;
  private lastWidth: number;
  private chart: any;
  private maxValueForXAxisHeight = 20;
  private xAxisLabelHeight = 0;
  private yLabelHeight = 0;
  private xAxisLabel: any;
  private yAxisLabel: any;
  private data: Array<any>;
  private xScale: any;
  private yScale: any;
  private xAxis: any;
  private yAxis: any;
  private colors: any[] = [];;
  private LegendWidthOffset: any;
  private LeftOffset: any = 0;
  private BottomOffset: any = 0;
  private mainChart: any;
  private legendHeightoffset: any = 0;
  private legendWidthOffset: any = 0;
  private titleHeight = 0;
  //style related

  private defaultStyle =
    {
      "background-color": "#F2F2F2",

      "tooltip-background": "White",
      "tooltip-font-color": "Black",
      "tooltip-font": "Sans-serif",
      "tooltip-font-size": 10,

      "legend-font-color": "#37474F",
      "legend-font": "Sans-serif",
      "legend-font-size": 10,
      "legend-visible": true,
      "legend-position": "right",

      "title-visible": true,
      "title-font-color": "#efefef",
      "title-font": "Sans-serif",
      "title-font-size": 14,
      "title-background-color": "#404040",

      "error-font-color": "Red",
      "error-font": "Sans-serif",
      "error-font-size": 14,

      "colors": ["#D32F2F", "#303F9F", "#4CAF50", "#F57C00", "#C2185B", "#1976D2", "#CDDC39", "#7B1FA2", "#FFC107", "#00796B"],

      "x-axis-color": "#37474F",
      "y-axis-color": "#37474F",
      "x-axis-font": "Sans-serif",
      "y-axis-font": "Sans-serif",
      "x-axis-font-size": 10,
      "y-axis-font-size": 10,
      "x-axis-label": "X_AXIS",
      "y-axis-label": "Y_AXIS",
      "x-axis-label-visible": true,
      "y-axis-label-visible": true,
      "margin": {
        "left": 5,
        "top": 5,
        "right": 5,
        "bottom": 5
      }
    }

  /*private allPositive: { key: string, value: number }[] = [
    { "key": "Emergency", "value": 0 },
    { "key": "Status", "value": 1 },
    { "key": "Fault", "value": 2 },
    { "key": "Life Safty", "value": 3 },
    { "key": "Low", "value": 4 },
    { "key": "trouble", "value": 5 },
    { "key": "Security", "value": 6 },
    { "key": "Medium", "value": 7 },
    { "key": "high", "value": 9 }
  ];

  private allNegetive: { key: string, value: number }[] = [
    { "key": "Emergency", "value": 0 },
    { "key": "Status", "value": -1 },
    { "key": "Fault", "value": -2 },
    { "key": "Life Safty", "value": -3 },
    { "key": "Low", "value": -4 },
    { "key": "trouble", "value": -5 },
    { "key": "Security", "value": -6 },
    { "key": "Medium", "value": -7 },
    { "key": "high", "value": -9 }
  ];

  private mixed: { key: string, value: number }[] = [
    { "key": "Emergency", "value": 0 },
    { "key": "Status", "value": -1 },
    { "key": "Fault", "value": 2 },
    { "key": "Life Safty", "value": -3 },
    { "key": "Low", "value": 4 },
    { "key": "trouble", "value": -5 },
    { "key": "Security", "value": 6 },
    { "key": "Medium", "value": -7 },
    { "key": "high", "value": -9 }
  ];*/

  private ERROR_TEXT_INVALID_DATA = "Cannot render chart - Invalid data supplied by provider.";
  private ERROR_TEXT = "Cannot fetch data for chart.";
  private ERROR_TEXT_INVALID_DATA_BAR = "Cannot render chart - value for all the events is zero (0)";

  @ViewChild('chart',{static:true}) private chartContainer: ElementRef;
  constructor(@Inject('dataProvider') dataProvider: any,
    @Inject("widgetStyle") widgetStyle: any,
    private injector: Injector/*private parameters: ParameterService,private http:Http*/,
    logger: LogService,
    private widgetHelper: WidegtHelperService,
    translateService: TranslateService) {
    super(logger, translateService);
    this.dataProvider = dataProvider;
    this.widgetStyle = widgetStyle;
    this.applyStyles();
  }

  ngOnDestroy() {
  }

  ngAfterViewInit() {
  }

  ngOnInit() {
    try {
      
      this.SetTransaltion();
      if (this.dataProvider && (this.dataProvider.name !== "")) {
      
        let provider = this.injector.get(this.dataProvider.name) as DataProvider;
        if (provider) {
          provider.getData(this);
        }
        else {
          let dataproviderName = (this.dataProvider) ? this.dataProvider.name : "";
          this.logger.logWarning("HorizontalBarChart", "Unable to instantiate dataprovider for chart. DataProvider name: " + dataproviderName)
          this.Draw(null);
        }
      }
    }
    catch (error) {
      this.logger.logError("HorizontalBarChart", "Unable to instantiate dataprovider for chart. Error:" + error);
    }
  }

  applyStyles() {
    for (let propName in this.defaultStyle) {
      var propertyName = propName.replace(/-/g, "_");
      let propValue = this.widgetStyle[propName];
      if (propValue !== undefined) {
        this.currentStyle[propertyName] = propValue;
      }
      else {
        this.currentStyle[propertyName] = this.defaultStyle[propName];
      }
    }
    this.logger.logInfo("HorizontalBarChart", " styles are: " + JSON.stringify(this.currentStyle));
  }

  createChart() {
    try {
      let element = this.chartContainer.nativeElement;
      if (element.offsetHeight != 0 && element.offsetWidth != 0) {

        if (typeof this.data === 'undefined' || this.data === null) {
          this.chartContainer.nativeElement.innerHTML = '';
          d3.select(element).append('svg')
            .attr('class', 'd3-chart1')
            .style('background-color', this.currentStyle.background_color)
            .attr('width', element.offsetWidth + 5)
            .attr('height', element.offsetHeight)
            .append('g').append('text')
            .attr('text-anchor', 'middle')
            .attr('transform', 'translate(' + (element.offsetWidth / 2) + ',' + (element.offsetHeight / 2) + ')')
            .style('font-size', this.currentStyle.error_font_size)
            .attr('font-size', this.currentStyle.error_font_size)
            .attr("font-family", this.currentStyle.error_font)
            .style('fill', this.currentStyle.error_font_color)
            .text(this.NAME + ":" + this.ERROR_TEXT)
            .call(this.widgetHelper.textWrap);
          return;
        }

        if (this.lastHeight != element.offsetHeight || this.lastWidth != element.offsetWidth) {

          this.chartContainer.nativeElement.innerHTML = '';
          let startColor = this.currentStyle.start_color;
          let endColor = this.currentStyle.end_color;
          this.colors = this.currentStyle.colors;
          //  this.colors = d3.scaleLinear().domain([0, this.data.length - 1]).range(<any[]>[startColor, endColor]);


          this.width = element.offsetWidth - this.currentStyle.margin.right - this.currentStyle.margin.left;
          this.height = element.offsetHeight - this.currentStyle.margin.bottom - this.currentStyle.margin.top;
          this.lastHeight = element.offsetHeight;
          this.lastWidth = element.offsetWidth;

          var svg = d3.select(element).append('svg')
            .style('background-color', this.currentStyle.background_color)
            .attr('width', element.offsetWidth)
            .attr('height', element.offsetHeight);

          this.mainChart = svg.append('g')
            .attr('width', this.width)
            .attr('height', this.height)
            .attr('transform', 'translate(' + this.currentStyle.margin.left + ',' + this.currentStyle.margin.top + ')');

          if (this.currentStyle.legend_visible)
            this.DrawLegends(false);

          if (this.currentStyle.x_axis_label_visible)
            this.drawXAxisLabel();
          if (this.currentStyle.y_axis_label_visible)
            this.drawYAxisLabel();
          var translates = this.getTranslateYForPie();

          this.chart = this.mainChart.append("g")
            .attr('class', 'barchart')
            .attr("transform", "translate(" + translates.x + "," + 0 + ")");

          this.DrawAxis();
          this.AdjustXAxis();
          this.AdjustYAxis();
          this.DrawAxis();
          this.updateChart();
          this.addToolTip();
        }
      }
    }
    catch (error) {
      this.logger.logError("HorizontalBarChart", "Error while creating Horizontal Bar Chart: " + error);
    }
  }

  AdjustYAxis() {
    let yAdjustment = 0;
    if (this.currentStyle.x_axis_label_visible)
      yAdjustment = 15;
    let xAxisHeight = this.xAxis.node().getBBox().height + yAdjustment;
    this.height = this.height - xAxisHeight;

    var bars = this.mainChart.selectAll('.barchart');

    let transform1 = bars.attr("transform");
    var split = bars.attr("transform").split(",");;
    var x = parseInt(split[0].split("(")[1]);
    var y = 1;

    let newY = y;

    if (this.currentStyle.legend_visible && this.currentStyle.legend_position == "top")
      newY = newY + this.legendHeightoffset + 10;

    let translate = "translate(" + (x) + "," + newY + ")"
    bars.attr("transform", translate)
  }

  AdjustXAxis() {
    var bars = this.mainChart.selectAll('.barchart');

    let transform1 = bars.attr("transform");

    var split = bars.attr("transform").split(",");;
    var x = parseInt(split[0].split("(")[1]);
    var y = 1;

    let newX = x + this.yAxis.node().getBBox().width;

    var xTranslate = this.currentStyle.legend_position == "left" &&
      this.currentStyle.legend_visible ?
      newX + 10 :
      newX

    let translate = "translate(" + (xTranslate) + "," + y + ")"
    bars.attr("transform", translate);

    let widthAdjustmentfactor = this.currentStyle.legend_visible && this.currentStyle.title_visible ? 10 : 30;

    if (this.currentStyle.legend_position == "right" && this.currentStyle.legend_visible)
      this.width = this.width - newX - widthAdjustmentfactor
    else if (this.currentStyle.legend_position == "left" && this.currentStyle.legend_visible)
      this.width = this.width - (newX / 2) - widthAdjustmentfactor;
    else
      this.width = this.width - newX - widthAdjustmentfactor;
  }

  getTranslateYForPie(): any {
    let translateX = 0;
    let translateY = 0;

    //legend adjustment
    if (this.currentStyle.legend_position == "left" && this.currentStyle.legend_visible) {
      translateX = this.legendWidthOffset
    }
    else if (this.currentStyle.legend_position == "right " && this.currentStyle.legend_visible) {
      translateX = this.currentStyle.margin.left;
    }
    else
      translateX = this.currentStyle.margin.left;
    if (this.currentStyle.y_axis_label_visible) {
      translateX = translateX + this.yLabelHeight + 5;
    }
    if (this.currentStyle.legend_position == "top" && this.currentStyle.legend_visible) {
      translateY = this.legendHeightoffset;

    }
    else if (this.currentStyle.legend_position == "bottom" && this.currentStyle.legend_visible) {
      translateY = this.currentStyle.margin.top;
    }
    else
      translateY = this.currentStyle.margin.top;
    if (this.currentStyle.x_axis_label_visible) {
      translateY = translateY + this.xAxisLabelHeight;
    }
    var translates = {
      "x": translateX,
      "y": translateY
    }
    return translates;
  }

  //Function to add tooltip on each bar
  private addToolTip() {
    var element = this.chartContainer.nativeElement;

    var tooltipDiv = d3.select(element).append("div").attr("class", "customToolTip");
    var barsforTooltip = this.chart.selectAll('.bar');

    barsforTooltip.on("mousemove", (d) => {
      if (navigator.userAgent.indexOf("Chrome") != -1) {
        tooltipDiv.style("left", d3.event.offsetX + 10 + "px");
        tooltipDiv.style("top", d3.event.offsetY - 25 + "px");
      }
      else {
        tooltipDiv.style("left", d3.event.x + 10 + "px");
        tooltipDiv.style("top", d3.event.y - 25 + "px");
      }
      tooltipDiv.style("display", "inline-block");
      tooltipDiv.style("background", this.currentStyle.tooltip_background);
      tooltipDiv.style('color', this.currentStyle.tooltip_font_color)
      tooltipDiv.style("font-size", this.currentStyle.tooltip_font_size + "px");
      tooltipDiv.style("font-family", this.currentStyle.tooltip_font);
      tooltipDiv.html((d.key) + "<br>" + (d.value.toLocaleString()) + " " + (d.Unit ? d.Unit : ""));
    });

    barsforTooltip.on("mouseout", (d) => {
      tooltipDiv.style("display", "none");
    });
  }
  private DrawLegends(haserror: boolean) {
    try {
      var legenddata: any = [];

      for (let i = 0; i < this.data.length; i++) {
        legenddata.push(
          {
            "key": this.data[i].key,
            "value": this.data[i].value,
            "color": this.getColor(i)
          });
      }

      var legendStyle = {
        "font-size": this.currentStyle.legend_font_size,
        "fill": this.currentStyle.legend_font_color,
        "font-family": this.currentStyle.legend_font
      }

      var widgetDimension = {
        "height": this.height,
        "width": this.width
      }

      let legendPosition = this.currentStyle.legend_position;

      if (this.mainChart.selectAll(".legendSectionMain"))
        this.mainChart.selectAll(".legendSectionMain").remove()


      let legend = this.mainChart.append('g')
        .attr("class", "legendSectionMain");

      var rowsinserted = this.widgetHelper.getDivisionForLegend(legendPosition, legendStyle, legenddata, legend, widgetDimension);

      if (legendPosition === "left" || legendPosition === "right") {
        this.legendWidthOffset = d3.max(this.mainChart.selectAll(".templegend").nodes(), (d: any) => { return d.getBBox().width as number })

        let yfactor = haserror && legendPosition === "left" ? this.titleHeight : 1
        let xfactor = legendPosition === "right" ? this.width - this.legendWidthOffset : 1;
        var translate = "translate(" + (xfactor) + "," + (yfactor) + ")"

        legend.attr("transform", translate);
        this.width = this.width - this.legendWidthOffset - 15;

      }
      else if (legendPosition == "top") {
        var yfactor = this.currentStyle.title_position == "top" || haserror ? this.titleHeight + 5 : 1;
        this.legendHeightoffset = d3.max(this.mainChart.selectAll(".templegend").nodes(), (d: any) => { return d.getBBox().height as number });
        var translate = "translate(" + (1) + "," + (yfactor) + ")"
        legend.attr("transform", translate);

        this.height = this.height - this.legendHeightoffset - 15;
      }
      else if (legendPosition === "bottom") {
        this.legendHeightoffset = d3.max(this.mainChart.selectAll(".templegend").nodes(), (d: any) => {
          return d.getBBox().height as number
        });
        //+ 5 as adjustmentfactor
        var yfactor = this.currentStyle.title_position == "bottom" ?
          (this.height - this.legendHeightoffset + 5) :
          (this.height - this.legendHeightoffset + this.titleHeight);
        var translate = "translate(" + (1) + "," + (yfactor) + ")"
        legend.attr("transform", translate);

        this.height = this.height - this.legendHeightoffset - 15;
      }
    }
    catch (error) {
      this.logger.logError("HorizontalBarChart", "Error while drawing Pie chart. Error:" + error);
    }
  }
  drawXAxisLabel() {
    try {
      this.mainChart.append('text')
        .attr('class', 'x_axis_label')
        .attr('text-anchor', 'middle')
        .style('font-size', this.currentStyle.x_axis_font_size)
        .attr('font-size', this.currentStyle.x_axis_font_size)
        .style('fill', this.currentStyle.x_axis_color)
        .attr("font-family", this.currentStyle.x_axis_font)
        .text(this.xAxisLabel ? this.xAxisLabel : this.currentStyle.x_axis_label);

      let xlabel = (this.mainChart.selectAll(".x_axis_label"))
      this.xAxisLabelHeight = xlabel ? xlabel.node().getBBox().height : 1;
      var yValue = (this.height - this.BottomOffset)
      if (this.currentStyle.legend_position == "top" && this.currentStyle.legend_visible) {
        yValue = yValue + this.legendHeightoffset + 15;
      }
      var xValue = this.width / 2;
      if (this.currentStyle.legend_position == "left" && this.currentStyle.legend_visible) {
        xValue = xValue + this.legendWidthOffset;
      }
      xlabel.attr('transform', 'translate(' + xValue + ',' + yValue + ')')
    }
    catch (error) {
      this.logger.logError("HorizontalBarChart", "Error while drawing X axis label. Error:" + error);
    }
  }
  drawYAxisLabel() {
    try {
      this.mainChart.append('text')
        .attr('class', 'y_axis_label')
        .attr('text-anchor', 'middle')
        .style('font-size', this.currentStyle.y_axis_font_size)
        .attr('font-size', this.currentStyle.y_axis_font_size)
        .style('fill', this.currentStyle.y_axis_color)
        .attr("font-family", this.currentStyle.y_axis_font)
        .text(this.yAxisLabel ? this.yAxisLabel : this.currentStyle.y_axis_label);
      let ylabel = (this.mainChart.selectAll(".y_axis_label"))
      this.yLabelHeight = ylabel ? ylabel.node().getBBox().height : 1;
      let xAdjustment = this.yLabelHeight;
      if (this.currentStyle.legend_position == "left" && this.currentStyle.legend_visible) {
        xAdjustment = this.yLabelHeight + this.legendWidthOffset
      }
      var yAdjustment = ((this.height - this.BottomOffset) / 2);
      if (this.currentStyle.legend_position == "top" && this.currentStyle.legend_visible) {
        yAdjustment = yAdjustment + this.legendHeightoffset;
      }
      ylabel.attr('transform', 'translate(' + xAdjustment + ',' + yAdjustment + ')rotate(-90)')
      this.width = this.width - (this.yLabelHeight);
    }
    catch (error) {
      this.logger.logError("HorizontalBarChart", "Error while drawing Y axis lab  el. Error:" + error);
    }
  }
  private DrawAxis() {
    this.chart.selectAll(".axis-x").remove();
    this.chart.selectAll(".axis-y").remove();

    let minValue = d3.min(this.data, d => d.value);
    if (minValue < 0) {
      var y0 = Math.max(Math.abs(d3.min(this.data, d => d.value)), Math.abs(d3.max(this.data, d => d.value)));
      // fixed the axis overlap issue, axis should be drawn having correct domian range        
      this.xScale = d3.scaleLinear().domain([-y0, y0]).range([0, this.width]).nice();
    }
    else {
      let maxValue = d3.max(this.data, d => d.value)
      this.xScale = d3.scaleLinear().domain([minValue, maxValue]).range([0, this.width]);
    }

    // create scales
    this.yScale = d3.scaleBand().padding(0.1).domain(this.data.map(d => d.key)).rangeRound([this.height, 0]);


    // x & y axis
    this.xAxis = this.chart.append('g')
      .attr('class', 'axis axis-x')
      .attr("transform", "translate(" + this.LeftOffset + "," + this.height + ")")
      .call(d3.axisBottom(this.xScale));

    this.yAxis = this.chart.append('g')
      .attr('class', 'axis axis-y')
      .attr("transform", "translate(" + this.LeftOffset + "," + this.BottomOffset + ")")
      .call(d3.axisLeft(this.yScale));

    this.xAxis.call(d3.axisBottom(this.xScale));
    this.yAxis.call(d3.axisLeft(this.yScale));


    this.xAxis.selectAll("text")
      .style("font-size", this.currentStyle.x_axis_font_size)
      .attr("font-size", this.currentStyle.x_axis_font_size)
      .style("font-family", this.currentStyle.x_axis_font);

    this.yAxis.selectAll("text")
      .style("font-size", this.currentStyle.y_axis_font_size)
      .attr("font-size", this.currentStyle.y_axis_font_size)
      .style("font-family", this.currentStyle.y_axis_font);

  }

  private dummyCounter = 0;
  Draw(responseData: BarChartResponseObject) {
    try {

      this.data = responseData != null ? responseData.ResponseArrayCollection[0] : null;
      this.xAxisLabel = responseData && responseData.xAxisLabel ? responseData.xAxisLabel : this.currentStyle.x_axis_label;
      this.yAxisLabel = responseData && responseData.yAxisLabel ? responseData.yAxisLabel : this.currentStyle.y_axis_label;
      // this.dummyCounter ++;
      let element = this.chartContainer.nativeElement;
      if (responseData && responseData.DataPointName && this.currentStyle.title_visible)
        element.offsetParent.getElementsByClassName('d3-chartTitle')[0].textContent = responseData.DataPointName;
      if (typeof this.data === 'undefined' || this.data === null) {
        this.logger.logWarning("HorizontalBarChart", this.ERROR_TEXT);
        this.chartContainer.nativeElement.innerHTML = '';
        d3.select(element).append('svg')
          .attr('class', 'd3-chart1')
          .attr('width', element.offsetWidth + 5)
          .attr('height', element.offsetHeight)
          .append('g').append('text')
          .attr('text-anchor', 'middle')
          .attr('transform', 'translate(' + (element.offsetWidth / 2) + ',' + (element.offsetHeight / 2) + ')')
          .style('font-size', this.currentStyle.error_font_size)
          .attr("font-family", this.currentStyle.error_font)
          .attr('font-size', this.currentStyle.error_font_size)
          .style('fill', this.currentStyle.error_font_color)
          .text(this.NAME + ":" + this.ERROR_TEXT)
          .call(this.widgetHelper.textWrap);
        return;
      }

      if (this.data.length == 0 || this.data.every(x => x == 0)) {
        //chart can not be drawn if all values are zero, so logging an warnning.
        this.logger.logWarning("HorizontalBarChart", "chart cannot be drawn for all zero values");
        return;
      }

      this.logger.logInfo("HorizontalBarChart", "Received callback from provider .Drawing widget");
      this.createChart();
    }
    catch (error) {
      this.logger.logError("HorizontalBarChart", "Error while creating Horizontal Bar Chart: " + error);
    }
  }

  private xAxisHeight = 0;
  Update(data: BarChartResponseObject) {
    if (data && data.ResponseArrayCollection[0]) {
      this.data = data.ResponseArrayCollection[0];

      /*if(this.dummyCounter == 1)
            this.data = this.mixed;
      else
        this.data = this.allPositive
      
      this.dummyCounter ++;*/

      let element = this.chartContainer.nativeElement;
      this.width = element.offsetWidth - (this.currentStyle.margin.right + this.currentStyle.margin.left);
      this.height = element.offsetHeight - (this.currentStyle.margin.bottom + this.currentStyle.margin.top);
      this.xAxisLabel = data && data.xAxisLabel ? data.xAxisLabel : this.currentStyle.x_axis_label;
      this.yAxisLabel = data && data.yAxisLabel ? data.yAxisLabel : this.currentStyle.y_axis_label;
      if (this.mainChart.selectAll(".templegend"))
        this.mainChart.selectAll(".templegend").remove()
      if (this.mainChart.selectAll(".barchart"))
        this.mainChart.selectAll(".barchart").remove()
      if (this.mainChart.selectAll(".x_axis_label"))
        this.mainChart.selectAll(".x_axis_label").remove()
      if (this.mainChart.selectAll(".y_axis_label"))
        this.mainChart.selectAll(".y_axis_label").remove()

      if (this.currentStyle.legend_visible)
        this.DrawLegends(false);


      if (this.data.length == 0 || this.data.every(x => x == 0)) {
        //chart can not be drawn if all values are zero, so logging an warnning.
        this.logger.logWarning("HorizontalBarChart", "chart cannot be drawn for all zero values");
        return;
      }

      if (this.currentStyle.x_axis_label_visible)
        this.drawXAxisLabel();
      if (this.currentStyle.y_axis_label_visible)
        this.drawYAxisLabel();
      var translates = this.getTranslateYForPie();
      this.chart = this.mainChart.append("g")
        .attr('class', 'barchart')
        .attr("transform", "translate(" + translates.x + "," + translates.y + ")");
      this.DrawAxis();
      this.AdjustXAxis();
      this.AdjustYAxis();
      this.DrawAxis();
      this.updateChart();
      var tooltipDiv = d3.select(element).select(".customToolTip");
      tooltipDiv.remove();
      this.addToolTip();
    }
  }

  updateChart() {
    try {
      // update scales & axis
      this.yScale.domain(this.data.map(d => d.key));

      var line = this.mainChart.selectAll('.center-x-line');
      if (line.node() != null || line.node() != undefined) {
        this.mainChart.selectAll('.center-x-line').remove();
      }

      let minValue = d3.min(this.data, d => d.value);
      let maxValue = d3.max(this.data, d => d.value);
      var allZer0 = this.data.every(x => x.value == 0);
      if (minValue < 0 && maxValue <= 0) {
        // values are -ve; Draw 0 to -ve
        var start = d3.min(this.data, d => d.value) - 1;
        this.xScale.domain([start, 0]);
        //this.colors.domain([0, this.data.length - 1]);
        this.xAxis.call(d3.axisBottom(this.xScale));
        this.yAxis.call(d3.axisLeft(this.yScale));

        let update = this.chart.selectAll('.bar')
          .data(this.data);

        this.chart.append("g")
          .attr("class", "center-x-line")
          .append("line")
          .attr("y1", 0)
          .attr("y2", (this.height - this.xAxisHeight))
          .attr("x1", (this.xScale(0) + 0.5))
          .style('stroke', this.currentStyle.x_axis_color)
          .attr("x2", (this.xScale(0) + 0.5));

        // remove exiting bars
        update.exit().remove();

        // update existing bars
        this.chart.selectAll('.bar').transition()
          .attr("x", (d) => {
            return this.xScale(Math.min(0, d.value));
          })
          .attr("height", this.yScale.bandwidth())
          .attr("y", (d) => { return this.yScale(d.key); })
          .attr("width", (d) => { return Math.abs(this.xScale(0) - this.xScale(d.value)); })
          .style('fill', (d, i) => this.getColor(i));

        // add new bars
        update
          .enter()
          .append('rect')
          .attr('class', 'bar')
          .attr("x", (d) => {
            return this.xScale(Math.min(0, d.value));
          })
          .attr("height", this.yScale.bandwidth())
          .attr("y", (d) => { return this.yScale(d.key); })
          .attr("width", (d) => { return Math.abs(this.xScale(0) - this.xScale(d.value)); })
          .style('fill', (d, i) => this.getColor(i));
      }
      else if ((minValue >= 0 && maxValue > 0) || allZer0) {
        this.xScale.domain([0, d3.max(this.data, d => d.value)]);
       // this.colors.domain([0, this.data.length - 1]);
        this.xAxis.call(d3.axisBottom(this.xScale));
        this.yAxis.call(d3.axisLeft(this.yScale));

        let update = this.chart.selectAll('.bar')
          .data(this.data);

        // remove exiting bars
        update.exit().remove();

        // update existing bars
        this.chart.selectAll('.bar').transition()
          .attr("x", this.LeftOffset + 1)
          .attr("height", this.yScale.bandwidth())
          .attr("y", (d) => { return this.yScale(d.key); })
          .attr("width", (d) => { return this.xScale(d.value); })
          .style('fill', (d, i) => this.getColor(i));

        // add new bars
        update
          .enter()
          .append('rect')
          .attr('class', 'bar')
          .attr("x", this.LeftOffset + 1)
          .attr("height", this.yScale.bandwidth())
          .attr("y", (d) => { return this.yScale(d.key); })
          .attr("width", (d) => { return this.xScale(d.value); })
          .style('fill', (d, i) => this.getColor(i));

      }
      else {
        //there are +ve and -ve values

        let length = 0
        if (this.currentStyle.legend_position == "left" && this.currentStyle.legend_visible == true)
          length = this.legendWidthOffset;
        var y0 = Math.max(Math.abs(d3.min(this.data, d => d.value)), Math.abs(d3.max(this.data, d => d.value)));
        // fixed the axis overlap issue, axis should be drawn having correct domian range        
        this.xScale.domain([-(y0 + 1), (y0 + 1)]).nice();

        this.chart.append("g")
          .attr("class", "center-x-line")
          .append("line")
          .attr("y1", 0)
          .attr("y2", (this.height - this.xAxisHeight))
          .attr("x1", (this.xScale(0) + 0.5))
          .style('stroke', this.currentStyle.x_axis_color)
          .attr("x2", (this.xScale(0) + 0.5));

      //  this.colors.domain([0, this.data.length - 1]);
        this.xAxis.call(d3.axisBottom(this.xScale));
        this.yAxis.call(d3.axisLeft(this.yScale));

        let update = this.chart.selectAll('.bar')
          .data(this.data);

        // remove exiting bars
        update.exit().remove();

        // update existing bars
        this.chart.selectAll('.bar').transition()
          .attr("height", this.yScale.bandwidth())
          .attr("y", (d) => this.yScale(d.key))
          .attr("width", (d) => { return Math.abs(this.xScale(0) - (this.xScale(d.value) - 0.5)); })
          .attr("x", (d) => {
            var value: number;
            value = d.value <= 0 ? this.xScale(Math.min(0, d.value)) : this.xScale(Math.min(0, d.value))
            let returnvalue = d.value < 0 ? (Math.floor(value)) : Math.ceil(value);
            return returnvalue;
          })
          .style('fill', (d, i) => this.getColor(i));

        // add new bars
        update
          .enter()
          .append('rect')
          .attr('class', 'bar')
          .attr("x", (d) => {
            var value: number;
            value = d.value <= 0 ? this.xScale(Math.min(0, d.value)) : this.xScale(Math.min(0, d.value))
            let returnvalue = d.value < 0 ? (Math.floor(value)) : Math.ceil(value);
            return returnvalue;
          })
          .attr("y", (d) => {
            return this.yScale(d.key);
          })
          .attr("width", (d) => { return Math.abs(this.xScale(0) - this.xScale(d.value)); })
          .attr("height", this.yScale.bandwidth())
          .style('fill', (d, i) => this.getColor(i));
      }


      this.chart.select('.axis-y').select('.domain').style('stroke', this.currentStyle.y_axis_color);
      this.chart.select('.axis-x').select('.domain').style('stroke', this.currentStyle.x_axis_color);
      this.chart.select('.axis-x').selectAll('.tick').selectAll('line').style('stroke', this.currentStyle.x_axis_color);
      this.chart.select('.axis-y').selectAll('.tick').selectAll('line').style('stroke', this.currentStyle.y_axis_color);
      this.chart.select('.axis-x').selectAll('.tick').selectAll('text').style('fill', this.currentStyle.x_axis_color);
      this.chart.select('.axis-y').selectAll('.tick').selectAll('text').style('fill', this.currentStyle.y_axis_color);
      // fixed the font size issue when updating the chart
      this.chart.select('.axis-x').selectAll('.tick').selectAll('text').style('font-size', this.currentStyle.x_axis_font_size)
      this.chart.select('.axis-y').selectAll('.tick').selectAll('text').style('font-size', this.currentStyle.y_axis_font_size)

      const transService = this.translateService;
      const currentLang = transService.currentLang;  
      this.chart.select('.axis-x').selectAll('.tick').selectAll('text').text(function (d) {
        var text = d;   
        return text.toLocaleString(currentLang) ;
      });  

      this.chart.select('.axis-y').selectAll('.tick').selectAll("text").text(function (d) {
        var text = d;    
        return text.toLocaleString(currentLang) ;
      });
    }
    catch (error) {
      this.logger.logError("HorizontalBarChart", "Error while creating Horizontal Bar Chart: " + error);
    }
  }

  getConfig() {
    return this.dataProvider.privateConfig;
  }

  private getColor(index: number): string {
    const multiple: number = Math.floor(index / 10) * 10;
    if (index > 9) {
      index = index - multiple;
    }
    return this.colors[index];
  }
}
